"use strict";

exports.__esModule = true;
exports["default"] = exports.SearchResultItem = exports.Link = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _header = _interopRequireDefault(require("../header"));

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Link = _styledComponents["default"].a.withConfig({
  displayName: "search-item__Link",
  componentId: "sc-13zlsnz-0"
})(["text-decoration:none;display:block;padding-bottom:32px;"]);

exports.Link = Link;
var propTypes = {
  /** ClassName for link */
  className: _propTypes.string,

  /** Description node  */
  description: _propTypes.node,

  /** Title node  */
  title: _propTypes.node,
  // Url for when a result item is a link
  url: _propTypes.string
};
var Title = (0, _styledComponents["default"])(_header["default"]).withConfig({
  displayName: "search-item__Title",
  componentId: "sc-13zlsnz-1"
})(["color:", ";", ";&:hover{color:", ";}"], function (props) {
  return (0, _styles.colors)("blue", props);
}, (0, _styles.defaultTransition)("color"), function (props) {
  return (0, _styles.themeDarken)("0.2", (0, _styles.colors)("blue", props));
});
var Description = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "search-item__Description",
  componentId: "sc-13zlsnz-2"
})(["overflow:hidden;text-overflow:ellipsis;color:", ";max-height:60px;letter-spacing:0.5px;"], function (props) {
  return (0, _styles.colors)("body-grey", props);
});

var SearchResultItem = function SearchResultItem(_ref) {
  var title = _ref.title,
      className = _ref.className,
      description = _ref.description,
      url = _ref.url;
  return /*#__PURE__*/_react["default"].createElement(Link, {
    className: className,
    href: url
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    fontSize: 3
  }, title), description ? /*#__PURE__*/_react["default"].createElement(Description, {
    fontSize: 2,
    lineHeight: 2,
    pt: 1
  }, description) : null);
};

exports.SearchResultItem = SearchResultItem;
SearchResultItem.propTypes = propTypes;
SearchResultItem.displayName = "Modules.SearchResultItem)";
var _default = SearchResultItem;
exports["default"] = _default;